// Cart Drawer — panoul glisant de coș.
//
// Principiul: JavaScript-ul NU calculeaza nimic despre cos (preturi, reduceri, subtotal,
// traduceri). Trimite operatia la Shopify (`/cart/add.js`, `/cart/change.js`) cerand in acelasi
// request re-randarea sectiunii `cart-drawer` (Section Rendering API, parametrul `sections`), si
// inlocuieste HTML-ul panoului cu ce a intors Shopify. Acelasi mecanism e deja folosit de bara
// de filtre (`facets.js`) — nu introducem un al doilea model de reimprospatare.
//
// Degradare eleganta: fara JS, iconita de cos ramane un link normal catre /cart, formularul de
// produs face submit clasic, iar linkurile de eliminare din drawer sunt `item.url_to_remove`
// reale. Orice eroare de retea cade inapoi pe navigarea normala catre /cart, nu lasa userul
// blocat fara feedback.
(function () {
  const SECTION_ID = 'cart-drawer';

  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const panel = drawer.querySelector('.td-cart-drawer__panel');
  let releaseFocus = null;
  let busy = false;

  // ---------------------------------------------------------------- deschidere/inchidere

  function open() {
    if (!drawer.hidden) return;
    drawer.hidden = false;
    window.TDOverlay.lock();
    releaseFocus = window.TDOverlay.trapFocus(drawer.querySelector('.td-cart-drawer__panel'));
  }

  function close() {
    if (drawer.hidden) return;
    drawer.hidden = true;
    window.TDOverlay.unlock();
    if (releaseFocus) { releaseFocus(); releaseFocus = null; }
  }

  // Delegare pe `drawer`, nu pe elementele individuale: continutul panoului e inlocuit complet
  // la fiecare re-randare, deci orice listener legat direct de un buton dinauntru ar disparea
  // dupa prima modificare (exact bug-ul gasit anterior in drawer-ul de filtre).
  drawer.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-drawer-close]')) {
      event.preventDefault();
      close();
      return;
    }
    const removeLink = event.target.closest('[data-cart-remove]');
    if (removeLink) {
      event.preventDefault();
      const line = removeLink.closest('[data-cart-line]');
      if (line) changeLine(line.dataset.cartLine, 0);
      return;
    }
    const down = event.target.closest('[data-cart-qty-down]');
    const up = event.target.closest('[data-cart-qty-up]');
    if (down || up) {
      event.preventDefault();
      const wrap = (down || up).closest('[data-cart-line]');
      const input = wrap.querySelector('[data-cart-qty-input]');
      const next = Math.max(0, parseInt(input.value, 10) + (up ? 1 : -1));
      changeLine(wrap.dataset.cartLine, next);
    }
  });

  drawer.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cart-qty-input]');
    if (!input) return;
    const wrap = input.closest('[data-cart-line]');
    const value = parseInt(input.value, 10);
    changeLine(wrap.dataset.cartLine, Number.isNaN(value) ? 1 : Math.max(0, value));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !drawer.hidden) close();
  });

  // ---------------------------------------------------------------- re-randare

  // Blocul de facturare pe firma traieste in footerul drawer-ului, deci dispare la fiecare
  // re-randare. Ce a apucat sa fie salvat pe cos vine inapoi in HTML-ul proaspat; ce era doar
  // tastat (salvarea se face la iesirea din camp) s-ar pierde la o simpla schimbare de cantitate.
  // De aceea il fotografiem inainte si il punem la loc dupa, fara sa batem valoarea de pe server.
  function snapshotBiz() {
    const el = drawer.querySelector('business-invoice');
    if (!el) return null;
    const checked = el.querySelector('[data-biz-type]:checked');
    const firma = el.querySelector('[data-biz-firma]');
    const cui = el.querySelector('[data-biz-cui]');
    return {
      tip: checked ? checked.value : null,
      firma: firma ? firma.value : '',
      cui: cui ? cui.value : '',
    };
  }

  function restoreBiz(state) {
    if (!state) return;
    const el = drawer.querySelector('business-invoice');
    if (!el) return;
    if (state.tip) {
      el.querySelectorAll('[data-biz-type]').forEach((input) => {
        input.checked = input.value === state.tip;
        const option = input.closest('.td-biz__option');
        if (option) option.classList.toggle('is-selected', input.checked);
      });
    }
    const firma = el.querySelector('[data-biz-firma]');
    const cui = el.querySelector('[data-biz-cui]');
    if (firma && state.firma && !firma.value) firma.value = state.firma;
    if (cui && state.cui && !cui.value) cui.value = state.cui;
    // Am bifat din cod, deci elementul nu a aflat: blocarea butonului de finalizare se recalculeaza.
    if (typeof el.syncGate === 'function') el.syncGate();
  }

  function applySection(html) {
    if (!html) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html')
      .querySelector('[data-cart-drawer]');
    if (!fresh) return;

    const wasOpen = !drawer.hidden;
    const biz = snapshotBiz();
    drawer.innerHTML = fresh.innerHTML;
    restoreBiz(biz);
    drawer.dataset.cartCount = fresh.dataset.cartCount || '0';
    if (wasOpen && releaseFocus) {
      // continutul vechi (si elementul focusat) tocmai a disparut — re-armam capcana de focus
      releaseFocus();
      releaseFocus = window.TDOverlay.trapFocus(drawer.querySelector('.td-cart-drawer__panel'));
    }
    syncHeaderCount();
  }

  function syncHeaderCount() {
    const count = parseInt(drawer.dataset.cartCount, 10) || 0;
    document.querySelectorAll('[data-cart-count-badge]').forEach((badge) => {
      badge.textContent = count;
      badge.hidden = count === 0;
    });
    // Eticheta plurala corecta o randeaza Shopify server-side la incarcarea paginii; aici doar
    // tinem numarul sincronizat, fara sa reimplementam regulile de plural in JS.
    document.querySelectorAll('[data-cart-link]').forEach((link) => {
      link.setAttribute('aria-label', `${link.dataset.cartLabel} (${count})`);
    });
  }

  async function postCart(url, body) {
    if (busy) return null;
    busy = true;
    if (panel) panel.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(Object.assign({ sections: SECTION_ID }, body)),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'cart error');
      return data;
    } finally {
      busy = false;
      if (panel) panel.removeAttribute('aria-busy');
    }
  }

  async function changeLine(line, quantity) {
    try {
      const data = await postCart('/cart/change.js', { line: Number(line), quantity });
      if (data) applySection(data.sections && data.sections[SECTION_ID]);
    } catch (error) {
      console.error('[cart-drawer] change esuat, trec pe pagina de cos:', error);
      window.location.href = '/cart';
    }
  }

  // ---------------------------------------------------------------- iconita din header

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-cart-link]');
    if (!trigger) return;
    // ctrl/cmd/middle-click => lasam browserul sa deschida /cart intr-un tab nou, ca la orice link
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    event.preventDefault();
    open();
  });

  // ---------------------------------------------------------------- adaugare din pagina de produs

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action$="/cart/add"]');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('[data-add-to-cart]');
    const label = form.querySelector('[data-add-to-cart-text]');
    const original = label ? label.textContent : null;
    if (button) button.disabled = true;
    if (label) label.textContent = label.dataset.addingLabel || label.textContent;

    const formData = new FormData(form);
    const payload = { items: [{ id: Number(formData.get('id')), quantity: Number(formData.get('quantity') || 1) }] };

    try {
      const data = await postCart('/cart/add.js', payload);
      if (data) {
        applySection(data.sections && data.sections[SECTION_ID]);
        open();
      }
    } catch (error) {
      console.error('[cart-drawer] adaugare esuata, trimit formularul normal:', error);
      form.submit();
      return;
    } finally {
      if (button) button.disabled = false;
      if (label && original !== null) label.textContent = original;
    }
  });

  syncHeaderCount();
})();
